/* Kyuman Bloom – JavaScript du thème (vanilla, sans dépendance) */
(() => {
  const $ = (sel, ctx = document) => ctx.querySelector(sel);
  const $$ = (sel, ctx = document) => Array.from(ctx.querySelectorAll(sel));
  const routes = (window.theme && window.theme.routes) || { root: '/', cart: '/cart', cartAdd: '/cart/add', cartChange: '/cart/change' };

  /* ---------- Barre d'annonce ---------- */
  $$('[data-rotator]').forEach((track) => {
    const items = $$('.announce__item', track);
    if (items.length < 2) return;
    let i = 0;
    setInterval(() => {
      items[i].classList.remove('is-active');
      i = (i + 1) % items.length;
      items[i].classList.add('is-active');
    }, Number(track.dataset.interval) || 4000);
  });

  /* ---------- <details> : fermeture au clic extérieur / Échap ---------- */
  document.addEventListener('click', (e) => {
    $$('details[open]').forEach((d) => {
      if (d.classList.contains('accordion__item') || d.closest('.accordion') || d.closest('.address-card') || d.classList.contains('password__login')) return;
      if (!d.contains(e.target)) d.removeAttribute('open');
    });
    const closer = e.target.closest('[data-close-details]');
    if (closer) closer.closest('details').removeAttribute('open');
  });
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    $$('details[open]:not(.accordion__item)').forEach((d) => d.removeAttribute('open'));
    closeDrawer();
  });
  const searchPop = $('.search-pop');
  if (searchPop) searchPop.addEventListener('toggle', () => { if (searchPop.open) $('input[type="search"]', searchPop).focus(); });

  /* ---------- Préférences cookies (bannière native Shopify) ---------- */
  document.addEventListener('click', (e) => {
    if (!e.target.closest('[data-cookie-preferences]')) return;
    if (window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function') {
      window.privacyBanner.showPreferences();
    } else if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], () => {
        if (window.privacyBanner) window.privacyBanner.showPreferences();
      });
    }
  });

  /* ---------- Panier ---------- */
  let drawer = $('[data-cart-drawer]');
  let lastFocus = null;

  function openDrawer() {
    if (!drawer) return;
    lastFocus = document.activeElement;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('is-locked');
    const panel = $('.drawer__panel', drawer);
    if (panel) panel.focus();
  }
  function closeDrawer() {
    if (!drawer || !drawer.classList.contains('is-open')) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('is-locked');
    if (lastFocus) lastFocus.focus();
  }

  function updateCount(count) {
    $$('[data-cart-count]').forEach((el) => {
      el.textContent = count;
      el.classList.toggle('is-empty', count === 0);
    });
    const link = $('.cart-link');
    if (link) { link.classList.remove('is-bumped'); void link.offsetWidth; link.classList.add('is-bumped'); }
  }

  function renderDrawer(html) {
    if (!drawer || !html) return;
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const fresh = $('[data-cart-drawer]', doc);
    if (fresh) drawer.innerHTML = fresh.innerHTML;
  }

  async function refreshCount() {
    const cart = await fetch(`${routes.cart}.js`, { headers: { Accept: 'application/json' } }).then((r) => r.json());
    updateCount(cart.item_count);
  }

  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-cart-toggle]') && drawer && window.theme.cartType === 'drawer') {
      e.preventDefault();
      openDrawer();
    }
    if (e.target.closest('[data-cart-close]')) closeDrawer();
  });

  // Ajout au panier AJAX
  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('form[data-product-form]');
    if (!form) return;
    e.preventDefault();
    const button = $('[type="submit"]', form);
    const error = $('[data-form-error]', form);
    if (button) button.classList.add('is-loading');
    if (error) error.hidden = true;

    const body = new FormData(form);
    body.append('sections', 'cart-drawer');
    body.append('sections_url', window.location.pathname);

    try {
      const res = await fetch(`${routes.cartAdd}.js`, { method: 'POST', body, headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' } });
      const data = await res.json();
      if (!res.ok || data.status) throw new Error(data.description || data.message || 'Erreur');
      if (window.theme.cartType === 'page') { window.location.href = routes.cart; return; }
      renderDrawer(data.sections && data.sections['cart-drawer']);
      await refreshCount();
      openDrawer();
    } catch (err) {
      if (error) { error.textContent = err.message; error.hidden = false; } else { alert(err.message); }
    } finally {
      if (button) button.classList.remove('is-loading');
    }
  });

  // Changement de quantité / suppression
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-line-change]');
    if (!btn) return;
    e.preventDefault();
    const line = Number(btn.closest('[data-line]').dataset.line);
    const quantity = Number(btn.dataset.lineChange);
    const inPage = btn.closest('[data-cart-page]');
    if (drawer) drawer.classList.add('is-loading');
    const res = await fetch(`${routes.cartChange}.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line, quantity, sections: ['cart-drawer'], sections_url: window.location.pathname })
    });
    const data = await res.json();
    if (inPage) { window.location.reload(); return; }
    renderDrawer(data.sections && data.sections['cart-drawer']);
    updateCount(data.item_count);
    if (drawer) drawer.classList.remove('is-loading');
  });

  /* ---------- Fiche produit ---------- */
  $$('[data-product]').forEach((root) => {
    const json = $('[data-variants-json]', root);
    const variants = json ? JSON.parse(json.textContent) : [];
    const form = $('form[data-product-form]', root);
    const idInput = $('[data-variant-id]', root);
    const addBtn = $('[data-add-button]', root);
    const addLabel = $('[data-add-label]', root);
    const priceWrap = $('[data-price-wrap] [data-price]', root);
    const stock = $('[data-stock]', root);
    const gallery = $('[data-gallery]', root);
    const thumbs = $$('[data-thumb]', root);
    const sticky = $('[data-sticky-atc]', root);

    const showMedia = (id) => {
      if (!gallery || !id) return;
      const slide = $(`[data-media-id="${id}"]`, gallery);
      if (slide) gallery.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
      thumbs.forEach((t) => t.classList.toggle('is-active', t.dataset.thumb === String(id)));
    };
    thumbs.forEach((t) => t.addEventListener('click', () => showMedia(t.dataset.thumb)));
    if (gallery) {
      gallery.addEventListener('scroll', () => {
        const index = Math.round(gallery.scrollLeft / gallery.clientWidth);
        thumbs.forEach((t, i) => t.classList.toggle('is-active', i === index));
      }, { passive: true });
    }

    // Quantité
    $$('[data-qty]', root).forEach((b) => b.addEventListener('click', () => {
      const input = $('.qty__input', root);
      input.value = Math.max(1, (Number(input.value) || 1) + Number(b.dataset.qty));
    }));

    // Variantes
    const inputs = $$('[data-option-input]', root);
    const update = () => {
      const selected = $$('.variant-picker', root).map((fs) => {
        const checked = $('input:checked', fs);
        const label = $('[data-option-value]', fs);
        if (checked && label) label.textContent = checked.value;
        return checked ? checked.value : null;
      });
      const v = variants.find((x) => x.options.every((o, i) => o === selected[i]));

      // Griser les valeurs indisponibles pour la 1re option
      $$('.variant-picker', root).forEach((fs, idx) => {
        $$('input', fs).forEach((inp) => {
          const ok = variants.some((x) => x.available && x.options[idx] === inp.value &&
            x.options.every((o, j) => j === idx || o === selected[j]));
          inp.closest('.chip').classList.toggle('is-unavailable', !ok);
        });
      });

      if (!v) {
        addBtn.disabled = true;
        addLabel.textContent = 'Indisponible';
        return;
      }
      idInput.value = v.id;
      addBtn.disabled = !v.available;
      addLabel.textContent = v.available ? 'Ajouter au panier' : 'Épuisé';
      if (priceWrap) {
        priceWrap.classList.toggle('price--sale', !!v.compare);
        priceWrap.innerHTML = `<span class="price__current">${v.price}</span>` +
          (v.compare ? `<s class="price__compare">${v.compare}</s><span class="price__saving">-${v.saving}&nbsp;%</span>` : '');
      }
      if (stock) {
        stock.innerHTML = !v.available
          ? '<span class="stock__dot stock__dot--out"></span> Épuisé pour le moment'
          : v.low
            ? `<span class="stock__dot stock__dot--low"></span> Plus que ${v.low} en stock`
            : '<span class="stock__dot"></span> En stock · expédié sous 1 à 3 jours ouvrés';
      }
      const sp = $('[data-sticky-price]', root);
      if (sp) sp.textContent = v.price.replace(/<[^>]+>/g, '');
      const sb = $('[data-sticky-add]', root);
      if (sb) sb.disabled = !v.available;
      if (v.media) showMedia(v.media);
      const url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url.toString());
    };
    inputs.forEach((i) => i.addEventListener('change', update));
    if (inputs.length) update();

    // Barre d'achat collante (mobile)
    if (sticky && addBtn && 'IntersectionObserver' in window) {
      new IntersectionObserver(([entry]) => {
        const show = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        sticky.classList.toggle('is-visible', show);
        sticky.setAttribute('aria-hidden', String(!show));
        $('[data-sticky-add]', sticky).tabIndex = show ? 0 : -1;
      }).observe(addBtn);
      $('[data-sticky-add]', sticky).addEventListener('click', () => form.requestSubmit());
    }
  });

  /* ---------- Recommandations produits ---------- */
  $$('[data-recommendations]').forEach(async (el) => {
    if (el.children.length && el.querySelector('.card')) return;
    try {
      const html = await fetch(el.dataset.url).then((r) => r.text());
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const fresh = $('[data-recommendations]', doc);
      if (fresh && fresh.innerHTML.trim()) el.innerHTML = fresh.innerHTML;
    } catch (_) { /* silencieux */ }
  });

  /* ---------- Filtres de collection : envoi automatique ---------- */
  $$('[data-facets]').forEach((form) => {
    let t;
    form.addEventListener('change', (e) => {
      if (!e.target.matches('[data-facet-input]')) return;
      clearTimeout(t);
      t = setTimeout(() => {
        const params = new URLSearchParams(new FormData(form));
        for (const [k, v] of Array.from(params.entries())) if (v === '') params.delete(k);
        window.location.search = params.toString();
      }, e.target.type === 'number' ? 700 : 0);
    });
  });

  /* ---------- Connexion : afficher la récupération de mot de passe ---------- */
  const recover = $('#recover');
  if (recover && window.location.hash !== '#recover') recover.hidden = true;
  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-toggle-recover]') && recover) { e.preventDefault(); recover.hidden = false; $('input', recover).focus(); }
  });
})();
